<template>
  <div>
    <div class="content">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" style="width: 60%;margin: auto"
               size="small">
        <el-form-item label="编号" prop="number">
          <el-input v-model="ruleForm.number" placeholder="请输入编号"/>
        </el-form-item>
        <el-form-item label="名称" prop="riskName">
          <el-input v-model="ruleForm.riskName" placeholder="请输入名称"/>
        </el-form-item>
        <el-form-item label="所属区域" prop="dangerAreaId">
          <el-select v-model="ruleForm.dangerAreaId" style="width: 100%" @change="areaChange">
            <el-option v-for="item in areaList" :key="item.id" :label="item.cellName" :value="item.id"/>
          </el-select>
        </el-form-item>
        <el-form-item label="所属部门" prop="depId">
          <el-select v-model="ruleForm.depId" style="width: 100%">
            <el-option v-for="item in departList" :key="item.id" :label="item.name" :value="item.id"/>
          </el-select>
        </el-form-item>
        <el-form-item label="风险点具体位置" prop="riskLocation">
          <el-input v-model="ruleForm.riskLocation" placeholder="请输入风险点具体位置"/>
        </el-form-item>
        <el-form-item label="风险类型" prop="riskType">
          <el-select v-model="ruleForm.riskType" style="width: 100%" @change="riskTypeChange">
            <el-option v-for="item in riskTypeArr" :key="item.id" :label="item.name" :value="item.id"/>
          </el-select>
        </el-form-item>
        <el-form-item label="关联报警" prop="alarmId">
          <el-select v-model="ruleForm.alarmId" style="width: 100%" @change="$forceUpdate()" multiple>
            <el-option v-for="item in alarmList" :key="item.id" :value="item.id" :label="item.name"/>
          </el-select>
        </el-form-item>
        <el-form-item v-if="ruleForm.riskType !== 0" label="分析方法分类" prop="analyticalMethodClassify">
          <el-select v-model="ruleForm.analyticalMethodClassify" style="width: 100%"
                     @change="methodsClassFyChange">
            <el-option :value="1" label="JHA"/>
            <el-option :value="2" label="SCL"/>
          </el-select>
        </el-form-item>
        <el-form-item label="分析方法" prop="analyticalMethod" v-if="ruleForm.riskType !== 0">
          <el-select v-model="ruleForm.analyticalMethod" style="width: 100%" @change="$forceUpdate()"
                     multiple>
            <el-option v-for="item in analyticalMethodArr" :key="item.id" :value="item.id"
                       :label="item.name"/>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label-width="0" style="margin-bottom: 5px" v-if="ruleForm.riskType !== 0"> -->
        <el-form-item label-width="0" style="margin-bottom: 5px">
          <el-col :span="12">
            <el-form-item label="辨识人员" prop="identifyEmpId">
              <el-select v-model="ruleForm.identifyEmpId" style="width: 100%">
                <el-option v-for="item in userList1" :key="item.id" :value="item.id"
                           :label="item.name"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="管控人员" prop="controllerEmpId">
              <el-select v-model="ruleForm.controllerEmpId" style="width: 100%">
                <el-option v-for="item in userList2" :key="item.id" :value="item.id"
                           :label="item.name"/>
              </el-select>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label-width="0" style="margin-bottom: 5px">
          <el-col :span="12">
            <el-form-item label="评估人员" prop="evaluatorEmpId">
              <el-select v-model="ruleForm.evaluatorEmpId" style="width: 100%">
                <el-option v-for="item in userList3" :key="item.id" :value="item.id"
                           :label="item.name"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="通知人" prop="adviceMans">
              <el-select v-model="ruleForm.adviceMans" style="width: 100%" multiple>
                <el-option v-for="item in userList" :key="item.id" :value="item.id" :label="item.name"/>
              </el-select>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label="评估时间" prop="evaluationTime">
          <el-date-picker
              v-model="ruleForm.evaluationTime"
              type="date"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: calc(50% - 60px)"
              placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="区域:" prop="coords">
          <el-input v-model="ruleForm.coords" type="textarea" :rows="2" placeholder="请点击选取区域!"/>
          <el-button type="text" @click="isVisibleDrawMap = true">选取</el-button>
        </el-form-item>
        <el-form-item label="风险等级" prop="color">
          <el-select v-model="ruleForm.color" style="width: 100%">
            <el-option v-for="item in colorArr" :key="item.id" :label="item.name" :value="item.id"/>
          </el-select>
        </el-form-item>
        <el-form-item label="管控层级" prop="color">
          <el-select v-model="ruleForm.controlHierarchy" style="width: 100%">
            <el-option v-for="item in controlHierarchyArr" :key="item.id" :label="item.name" :value="item.id"/>
          </el-select>
        </el-form-item>

        <el-form-item label="高度" prop="height">
          <el-input-number v-model="ruleForm.height" controls-position="right" :min="1" :max="100"></el-input-number>
        </el-form-item>

        <el-form-item style="margin-top: 40px">
          <el-button type="primary" style="width: 100%" @click="submit">保存</el-button>
        </el-form-item>
      </el-form>
      <DrawMap v-if="isVisibleDrawMap" :initCoords="getCoord()" :drawType="'Polygon'"
               :closeDrawer="closeDrawer"></DrawMap>
    </div>
  </div>
</template>

<script>
import {
  getAreaList, getAllDepartment, getAlarmByReginId, getStaffList,
  riskPointAdd, riskPointDetail, riskPointUpdate, getPermisssionEmpList
} from "@/api/processManager";
import DrawMap from "@/views/map/drawMap";

export default {
  name: 'AddRiskPoint',
  components: {
    DrawMap
  },
  props: {
    callBack: Function,
    riskPoint: Object
  },
  data() {
    return {
      isVisibleDrawMap: false,
      ruleForm: {
        analyticalMethod: [],
        adviceMans: [],
        alarmId: []
      },
      rules: {
        number: [{required: true, message: '请输入', trigger: 'blur'}],
        riskName: [{required: true, message: '请输入', trigger: 'blur'}],
        dangerAreaId: [{required: true, message: '请选择', trigger: 'blur'}],
        depId: [{required: true, message: '请选择', trigger: 'blur'}],
        riskLocation: [{required: true, message: '请输入', trigger: 'blur'}],
        riskType: [{required: true, message: '请选择', trigger: 'blur'}],
        // alarmId: [{ required: true, message: '请选择', trigger: 'blur' }],
        analyticalMethodClassify: [{required: true, message: '请选择', trigger: 'blur'}],
        analyticalMethod: [{required: true, message: '请选择', trigger: 'blur'}],
        identifyEmpId: [{required: true, message: '请选择', trigger: 'blur'}],
        controllerEmpId: [{required: true, message: '请选择', trigger: 'blur'}],
        evaluatorEmpId: [{required: true, message: '请选择', trigger: 'blur'}],
        adviceMans: [{required: true, message: '请选择', trigger: 'blur'}],
        evaluationTime: [{required: true, message: '请选择', trigger: 'blur'}],
      },
      // 风险类型的数组
      riskTypeArr: [
        {name: '固有风险', id: 0},
        {name: '作业风险', id: 1},
        {name: '设备风险', id: 2}
      ],
      colorArr: [
        {name: '重大风险', id: "重大风险"},//重大风险=红色,#ff0000
        {name: '较大风险', id: "较大风险"},//较大风险=橙色,#ffa500
        {name: '一般风险', id: "一般风险"},//一般风险=黄色,#ffff00
        {name: '低风险', id: "低风险"}//低风险=蓝色,#0000ff
      ],
      controlHierarchyArr:[
        {name: '公司级', id: 0},//重大风险=红色,#ff0000
        {name: '车间级', id: 1},
        {name: '部门级', id: 2},//较大风险=橙色,#ffa500
        {name: '班组级', id: 3},//一般风险=黄色,#ffff00
        {name: '岗位级', id: 4}
      ],
      // 分析方法的数组
      analyticalMethodArr: [],
      // 区域的数组
      areaList: [],
      // 部门列表
      departList: [],
      // 根据区域id查询到的报警器id
      alarmList: [],
      // 员工（人员的列表）
      userList: [],
      userList1: [],
      userList2: [],
      userList3: [],
    }
  },
  watch: {
    // 监听状态
    riskPoint(val) {
      if (val) {
        this.init();
      }
    }
  },
  created() {
    this.init();
  },
  methods: {
    init() {

      this.getArea();
      this.getDepart();
      this.getAllEmp();
      let arr = JSON.parse(localStorage.getItem('Permission'))
      for (let i in arr) {
        if (arr[i].menuName !== '列表') {
          this.getPermisssionEmpList(arr[i].id, arr[i].menuName)
        }
      }
      // 编辑
      if (this.riskPoint) {
        riskPointDetail(this.riskPoint.id).then(res => {
          let obj = res.body.data;
          obj.coords = this.riskPoint.coords;
          this.$set(this.ruleForm, 'id', obj.id)
          this.$set(this.ruleForm, 'number', obj.number)
          this.$set(this.ruleForm, 'riskName', obj.riskName)
          this.$set(this.ruleForm, 'dangerAreaId', obj.dangerAreaId)
          this.$set(this.ruleForm, 'depId', obj.depId)
          this.$set(this.ruleForm, 'riskLocation', obj.riskLocation)
          this.$set(this.ruleForm, 'riskType', obj.riskType)
          this.$set(this.ruleForm, 'coords', obj.coords)
          this.$set(this.ruleForm, 'color', obj.color)
          this.$set(this.ruleForm, 'height', obj.height)
          if (obj.alarmId) {
            let arr = obj.alarmId.split(',')
            for (let i in arr) {
              arr[i] = Number(arr[i])
            }
            this.$set(this.ruleForm, 'alarmId', arr)
          }
          this.$set(this.ruleForm, 'analyticalMethodClassify', obj.analyticalMethodClassify)
          this.$set(this.ruleForm, 'analyticalMethod', obj.analyticalMethod.split(','))
          this.$set(this.ruleForm, 'identifyEmpId', obj.identifyEmpId)
          this.$set(this.ruleForm, 'controllerEmpId', obj.controllerEmpId)
          this.$set(this.ruleForm, 'evaluatorEmpId', obj.evaluatorEmpId)
          this.$set(this.ruleForm, 'adviceMans', JSON.parse(obj.adviceMans))
          this.$set(this.ruleForm, 'evaluationTime', obj.evaluationTime)
          if (obj.analyticalMethodClassify == 1) {
            this.analyticalMethodArr = [
              {name: 'JHA_LS', id: '1'},
              {name: 'JHA_LEC', id: '2'},
              {name: 'JHA_MES', id: '3'}
            ]
          }
          if (obj.analyticalMethodClassify == 2) {
            this.analyticalMethodArr = [
              {name: 'SCL_LS', id: '4'},
              {name: 'SCL_LEC', id: '5'},
              {name: 'SCL_MES', id: '6'}
            ]
          }
          getAlarmByReginId(obj.dangerAreaId).then(res => {
            this.alarmList = res.body.data;
          })
        })
      }
    },

    getCoord() {
      if (this.ruleForm.coords) {
        return JSON.parse(this.ruleForm.coords)
      }
      return []
    },
    closeDrawer(drawData) {
      if (drawData) {
        this.ruleForm.coords = JSON.stringify(drawData.positions)
      }
      this.isVisibleDrawMap = false;
    },
    // 获取区域列表
    getArea() {
      getAreaList({limit: 500, curPage: 1}).then(res => {
        this.areaList = res.body.data;
        console.log(this.areaList)
      })
    },
    // 区域改变
    areaChange(id) {
      this.ruleForm.alarmId = '';
      // 根据区域id查报警器
      getAlarmByReginId(id).then(res => {
        this.alarmList = res.body.data;
      })
    },
    // 风险类别改变
    riskTypeChange(val) {
      // 为固有风险的时候 隐藏分析类别和分析方法（但是后端做了必填校验，默认赋一个值）
      if (val === 0) {
        this.ruleForm.analyticalMethod = ['100'];
        this.ruleForm.analyticalMethodClassify = 100;
      } else {
        this.ruleForm.analyticalMethod = [];
        this.ruleForm.analyticalMethodClassify = '';
      }
    },
    // 分析分类选择
    methodsClassFyChange(val) {
      this.$set(this.ruleForm, 'analyticalMethodClassify', val)
      this.ruleForm.analyticalMethod = [];
      if (val == 1) {
        this.analyticalMethodArr = [
          {name: 'JHA_LS', id: '1'},
          {name: 'JHA_LEC', id: '2'},
          {name: 'JHA_MES', id: '3'}
        ]
      }
      ;
      if (val == 2) {
        this.analyticalMethodArr = [
          {name: 'SCL_LS', id: '4'},
          {name: 'SCL_LEC', id: '5'},
          {name: 'SCL_MES', id: '6'}
        ]
      }
    },
    // 获取所有部门的列表
    getDepart() {
      getAllDepartment().then(res => {
        this.departList = res.body.data
      })
    },
    // 获取所有员工的列表
    getAllEmp() {
      getStaffList().then(res => {
        this.userList = res.body.data;
      })
    },
    // 获取有当前页面操作权限的人员的列表
    getPermisssionEmpList(id, status) {
      getStaffList({permissionId: id}).then(res => {
      //getPermisssionEmpList({permissionId: id}).then(res => {
        if (status === '辨识') {
          this.userList1 = res.body.data
        } else if (status === '管控') {
          this.userList2 = res.body.data
        } else {
          this.userList3 = res.body.data
        }
      })
    },
    // 保存按钮
    submit() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          let obj = {...this.ruleForm}
          obj.analyticalMethod = this.ruleForm.analyticalMethod.join(',')
          if (obj.alarmId) {
            obj.alarmId = this.ruleForm.alarmId.join(',')
          }
          obj.adviceMans = JSON.stringify(this.ruleForm.adviceMans)
          // 编辑
          if (this.ruleForm.id != undefined) {
            obj.id = this.ruleForm.id
            riskPointUpdate(obj).then(res => {
              this.$message.success('保存成功');
              this.callBack && this.callBack();
            })
          } else {
            riskPointAdd(obj).then(res => {
              this.$message.success('保存成功');
              this.callBack && this.callBack();
            })
          }
        } else {
          return false;
        }
      });
    }
  }
}
</script>

<style scoped>

</style>
